"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState, useTransition } from "react";
import * as AuthActions from "@/serverActions/auth.action";
import { setSentryHostContext, setSentryUser } from "@/utils/sentry.util";
import { PlayerSetupContext } from "./context.provider";
import type { IPlayerSetupContainer } from "@/containers/playerSetup.container";
import type { Dispatch, FC, PropsWithChildren, SetStateAction } from "react";
interface IProps extends IPlayerSetupContainer {}
export type TPlayerSetupContext = IProps & {
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  joinGame: () => void;
  isPendingPlayerLogin: boolean;
  joinGameButtonRef: React.RefObject<HTMLButtonElement | null>;
  handleKeyDown: (e: React.KeyboardEvent) => void;
};
export const PlayerSetupProvider: FC<PropsWithChildren<IProps>> = props => {
  const $ = _c(15);
  const [name, setName] = useState("");
  const [isPendingPlayerLogin, startTransitionPlayerLogin] = useTransition();
  const joinGameButtonRef = useRef(null);
  let t0;
  if ($[0] !== isPendingPlayerLogin || $[1] !== name) {
    t0 = e => {
      if (e.key === "Enter" && !isPendingPlayerLogin && name.trim()) {
        joinGameButtonRef.current?.click();
      }
    };
    $[0] = isPendingPlayerLogin;
    $[1] = name;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleKeyDown = t0;
  let t1;
  if ($[3] !== name || $[4] !== props.params) {
    t1 = async () => {
      startTransitionPlayerLogin(async () => {
        setSentryUser({
          id: `player_${name}_${Date.now()}`,
          username: name,
          role: "player"
        });
        setSentryHostContext({
          hostUsername: props.params.hostUsername
        });
        await AuthActions.playerLoginAction({
          name,
          hostUsername: props.params.hostUsername
        });
      });
    };
    $[3] = name;
    $[4] = props.params;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const joinGame = t1;
  let t2;
  if ($[6] !== handleKeyDown || $[7] !== isPendingPlayerLogin || $[8] !== joinGame || $[9] !== name || $[10] !== props) {
    t2 = {
      ...props,
      name,
      setName,
      joinGame,
      isPendingPlayerLogin,
      joinGameButtonRef,
      handleKeyDown
    };
    $[6] = handleKeyDown;
    $[7] = isPendingPlayerLogin;
    $[8] = joinGame;
    $[9] = name;
    $[10] = props;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== props.children || $[13] !== t2) {
    t3 = <PlayerSetupContext.Provider value={t2}>{props.children}</PlayerSetupContext.Provider>;
    $[12] = props.children;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};